import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ITALY_CENTER = [42.3, 12.5];
const eur = (v) => `${Number(v || 0).toFixed(2)} €`;
const defaultTip = (p) => `<b>${p.name}</b><br>${p.count} scontrini · media ${eur(p.avg_total)}`;

export default function StoreReceiptsMap({ rows, metric = "count", tooltip = defaultTip, height = 360, testId = "receipt-store-map", emptyText }) {
  const el = useRef(null);
  const pts = (rows || []).filter((r) => r.geo?.lat && r.geo?.lng && (r[metric] || 0) > 0);
  useEffect(() => {
    if (!el.current || !pts.length) return undefined;
    const map = L.map(el.current, { center: ITALY_CENTER, zoom: 5.5, scrollWheelZoom: false, zoomSnap: 0.5 });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' }).addTo(map);
    const max = Math.max(...pts.map((p) => p[metric]), 1);
    pts.forEach((p, i) => {
      L.circleMarker([p.geo.lat, p.geo.lng], { radius: 10 + 30 * Math.sqrt(p[metric] / max), color: "#1d4ed8", fillColor: i === 0 ? "#10b981" : "#3b82f6", fillOpacity: 0.55, weight: 2 })
        .addTo(map)
        .bindTooltip(tooltip(p), { direction: "top", permanent: i < 3 });
    });
    return () => { map.remove(); };
  }, [pts.map((p) => `${p.store_id}:${p[metric]}`).join("|"), metric]); // eslint-disable-line react-hooks/exhaustive-deps -- ricrea la mappa solo quando cambiano sedi, valori o metrica
  if (!pts.length) return <p className="text-[11px] text-muted-foreground" data-testid={`${testId}-empty`}>{emptyText || "Nessuna sede geolocalizzata: compila CAP e città nella pagina Sedi per vederle sulla mappa."}</p>;
  return <div ref={el} style={{ height, zIndex: 0, isolation: "isolate" }} className="relative overflow-hidden rounded-xl border border-border" data-testid={testId} />;
}
